module.exports = __webpack_public_path__ + "static/media/Artboard3.dffeab84.png";